module.exports = __webpack_public_path__ + "static/media/recortes_home_06.ca06e90f.jpg";